import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const dataVendorStreamApiSlice = apiSlice.injectEndpoints({

  endpoints: (builder) => ({
    getDataVendorStream: builder.query({
      query: ([dataVendorId, streamKey]) => `/data_vendors/${dataVendorId}/streams/${streamKey}`,
      providesTags: (result, error, arg) => [{ type: 'DataVendorStream', id: arg[1] }],
    }),
    getDataVendorStreamAnalytics : builder.query({
      query: ([dataVendorId, streamKey]) => `/data_vendors/${dataVendorId}/streams/${streamKey}/stats`
    }),
    createDataVendorStream: builder.mutation({
      query: (stream) => ({
        url: `/data_vendors/${stream.dataVendorId}/streams/`,
        method: 'POST',
        body: stream
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'DataVendor', id: arg.dataVendorId },
        { type: 'DataVendorStream', id: 'LIST' }],
    }),
    updateDataVendorStream: builder.mutation({
      query: (stream) => ({
        url: `/data_vendors/${stream.dataVendorId}/streams/${stream.key}`,
        method: 'PUT',
        body: stream,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'DataVendor', id: arg.dataVendorId },
        { type: 'DataVendorStream', id: arg.key }
      ]
    }),
    deleteDataVendorStream: builder.mutation({
      query: ([dataVendorId, streamId]) => ({
        url: `/data_vendors/${dataVendorId}/streams/${streamId}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'DataVendor', id: arg.dataVendorId },
        { type: 'DataVendorStream', id: arg.streamId }
      ]
    }),
  }),
  overrideExisting: false
})

export const {
  useGetDataVendorStreamQuery,
  useGetDataVendorStreamAnalyticsQuery,
  useCreateDataVendorStreamMutation,
  useUpdateDataVendorStreamMutation,
  useDeleteDataVendorStreamMutation
} = dataVendorStreamApiSlice
